module.exports = __webpack_public_path__ + "img/boc.b5a8c595.png";